<template>
  <div class="contentArea">
    <vs-row
      v-if="type == 'curriculum' || type == 'course' || type == 'banner'"
      class="card-area"
    >
      <vs-col vs-lg="1.5" vs-sm="2" vs-xs="12">
        <button @click="$router.go(-1)" class="back-btn">
          <img src="@/assets/images/elements/turnback.svg" />
          กลับ
        </button>
      </vs-col>
      <vs-col
        vs-lg="7"
        vs-sm="8"
        vs-xs="12"
        class="flex flex-col justify-center"
      >
        <Addcurriculum v-if="type == 'curriculum'" />
        <Addcourse v-if="type == 'course'" />
        <Addbanner v-if="type == 'banner'" />
      </vs-col>
      <vs-col vs-lg="1.5" vs-sm="2" vs-xs="0"></vs-col>
    </vs-row>
    <vs-row v-else class="card-area">
      <vs-col vs-lg="4" vs-sm="3" vs-xs="12">
        <button @click="$router.go(-1)" class="back-btn">
          <img src="@/assets/images/elements/turnback.svg" />
          กลับ
        </button>
      </vs-col>
      <vs-col
        vs-lg="4"
        vs-sm="6"
        vs-xs="12"
        class="flex flex-col justify-center"
      >
        <Addadministrator v-if="type == 'administrator'" />
        <AddcurriculumType v-if="type == 'curriculumType'" />
        <Addorganization v-if="type == 'organization'" />
        <Addvideo v-if="type == 'video'" />
        <Addlecturer v-if="type == 'lecturer'" />
      </vs-col>
      <vs-col vs-lg="4" vs-sm="3" vs-xs="0"></vs-col>
    </vs-row>
  </div>
</template>

<script>
import AddcurriculumType from "@/views/elements/course/addcurriculumType.vue";
import Addcurriculum from "@/views/elements/course/addcurriculum.vue";
import Addorganization from "@/views/elements/course/addorganization.vue";
import Addcourse from "@/views/elements/course/addcourse.vue";
import Addvideo from "@/views/elements/course/addvideo.vue";
import Addlecturer from "@/views/elements/course/addlecturer.vue";
import Addbanner from "@/views/elements/course/addbanner.vue";
import Addadministrator from "@/views/elements/course/addadministrator.vue";

export default {
  props: {
    type: String
  },
  components: {
    AddcurriculumType,
    Addcurriculum,
    Addorganization,
    Addcourse,
    Addvideo,
    Addlecturer,
    Addbanner,
    Addadministrator
  }
};
</script>

<style lang="scss" scoped>
.card-area {
  padding: 30px 20px;
  justify-content: center;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.6);
}
.back-btn {
  background: none !important;
  border: none;
}
</style>
